"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var AbstractRelease_1 = require("./AbstractRelease");

var Release_1 = require("./Release");

var ReleaseState_1 = require("./ReleaseState");

var ReleaseType_1 = require("./ReleaseType");

var SelloutImpactRecordStockValues_1 = require("./sellout/SelloutImpactRecordStockValues");

var SelloutImpactRecordValuesForOpen_1 = require("./sellout/SelloutImpactRecordValuesForOpen");

var SelloutRelease_1 = require("./sellout/SelloutRelease");

var SelloutReleasePreviousOpenOverview_1 = require("./sellout/SelloutReleasePreviousOpenOverview");
/**
 * Data required for display of a list of releases in releases overview.
 *
 * @author Jan Prokop
 */


var CommonReleaseOverview =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CommonReleaseOverview, _DomainObject_1$Domai);

  /**
   * @param id                         AbstractRelease#id
   * @param name                       AbstractRelease#name
   * @param releaseType                AbstractRelease#releaseType
   * @param workflowType               AbstractRelease#workflowType
   * @param state                      AbstractRelease#state
   * @param pricingType                Release#pricingType
   * @param priceListType              AbstractRelease#priceListType
   * @param cmDeadline                 AbstractRelease#cmDeadline
   * @param priceValidityStartDate     AbstractRelease#priceValidityStartDate
   * @param endDate                    SelloutRelease#endDate
   * @param exported                   AbstractRelease#exported
   * @param favourite                  AbstractRelease#favourite
   * @param totalPriceChangeLimit      AbstractRelease#totalPriceChangeLimit
   * @param minPriceChangeInPercent    SelloutRelease#minPriceChangeInPercent
   * @param maxPriceChangeInPercent    SelloutRelease#maxPriceChangeInPercent
   * @param minMarginChangeInPercent   SelloutRelease#minMarginChangeInPercent
   * @param stockValues
   * @param currentImpact
   * @param previousOpens
   */
  function CommonReleaseOverview(id, name, releaseType, // regular, simulation, sellout ...
  workflowType, state, pricingType, // national or local
  priceListType, cmDeadline, // missing for some workflow types
  priceValidityStartDate, // null in Urgent
  endDate, // filled for non-urgent EDLP releases (LOG-4786)
  exported, favourite, totalPriceChangeLimit, // null in Urgent or in delists (LOG-5674)
  minPriceChangeInPercent, // null in Urgent
  maxPriceChangeInPercent, minMarginChangeInPercent, // null in Urgent
  stockValues, currentImpact, previousOpens) {
    var _this;

    _classCallCheck(this, CommonReleaseOverview);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CommonReleaseOverview).call(this));
    _this.id = id;
    _this.name = name;
    _this.releaseType = releaseType;
    _this.workflowType = workflowType;
    _this.state = state;
    _this.pricingType = pricingType;
    _this.priceListType = priceListType;
    _this.cmDeadline = cmDeadline;
    _this.priceValidityStartDate = priceValidityStartDate;
    _this.endDate = endDate;
    _this.exported = exported;
    _this.favourite = favourite;
    _this.totalPriceChangeLimit = totalPriceChangeLimit;
    _this.minPriceChangeInPercent = minPriceChangeInPercent;
    _this.maxPriceChangeInPercent = maxPriceChangeInPercent;
    _this.minMarginChangeInPercent = minMarginChangeInPercent;
    _this.stockValues = stockValues;
    _this.currentImpact = currentImpact;
    _this.previousOpens = previousOpens;

    _this.fixCopy(_assertThisInitialized(_assertThisInitialized(_this)));

    return _this;
  }

  _createClass(CommonReleaseOverview, [{
    key: "fixCopy",
    value: function fixCopy(copy) {
      // Make daysSinceFirstRepricing and daysSinceLastRepricing enumerable
      var _arr = ['daysSinceFirstRepricing', 'daysSinceLastRepricing'];

      for (var _i = 0; _i < _arr.length; _i++) {
        var property = _arr[_i];
        var descriptor = Object.getOwnPropertyDescriptor(CommonReleaseOverview.prototype, property);
        Object.defineProperty(copy, property, Object.assign(Object.assign({}, descriptor), {
          enumerable: true
        }));
      }

      return copy;
    }
  }, {
    key: "daysSinceFirstRepricing",
    get: function get() {
      if (this.releaseType === ReleaseType_1.ReleaseType.Sellout) {
        var now = moment().startOf('day');
        var initialOpen = this.previousOpens.get(0);
        var initialPriceValidityStartDate = initialOpen ? initialOpen.priceValidityStartDate : this.priceValidityStartDate;

        if (initialPriceValidityStartDate) {
          var daysSinceFirstRepricing = now.diff(initialPriceValidityStartDate, 'days') + 1;

          if (daysSinceFirstRepricing > 0 && this.state !== ReleaseState_1.ReleaseState.Inactive) {
            return daysSinceFirstRepricing;
          }
        }
      }

      return null;
    }
  }, {
    key: "daysSinceLastRepricing",
    get: function get() {
      if (this.releaseType === ReleaseType_1.ReleaseType.Sellout) {
        var now = moment().startOf('day');
        var priceValidityStartDate = this.priceValidityStartDate;

        if (priceValidityStartDate) {
          var daysSinceLastRepricing = now.diff(priceValidityStartDate, 'days') + 1;

          if (daysSinceLastRepricing > 0 && this.state !== ReleaseState_1.ReleaseState.Inactive) {
            return daysSinceLastRepricing;
          }
        }
      }

      return null;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new CommonReleaseOverview(mat.id, mat.name, mat.releaseType, mat.workflowType, mat.state, mat.pricingType, mat.priceListType, mat.cmDeadline, mat.priceValidityStartDate, mat.endDate, mat.exported, mat.favourite, mat.totalPriceChangeLimit, mat.minPriceChangeInPercent, mat.maxPriceChangeInPercent, mat.minMarginChangeInPercent, mat.stockValues, mat.currentImpact, mat.previousOpens);
    }
  }, {
    key: "createFromRelease",
    value: function createFromRelease(release) {
      var mat = Object.assign({}, release);

      if (SelloutRelease_1.SelloutRelease.isSelloutRelease(release) && release.reopenSnapshots) {
        mat.previousOpens = release.reopenSnapshots;
      } else {
        mat.previousOpens = immutable_1.List();
      }

      return CommonReleaseOverview.fromDataDict(mat);
    }
  }]);

  return CommonReleaseOverview;
}(DomainObject_1.DomainObject);

exports.CommonReleaseOverview = CommonReleaseOverview;

CommonReleaseOverview.schema = function (builder) {
  return {
    id: AbstractRelease_1.AbstractRelease.schemaBase.id,
    name: AbstractRelease_1.AbstractRelease.schemaBase.name,
    releaseType: AbstractRelease_1.AbstractRelease.schemaBase.releaseType,
    workflowType: AbstractRelease_1.AbstractRelease.schemaBase.workflowType,
    state: AbstractRelease_1.AbstractRelease.schemaBase.state,
    pricingType: Release_1.Release.schema.pricingType,
    priceListType: AbstractRelease_1.AbstractRelease.schemaBase.priceListType,
    cmDeadline: AbstractRelease_1.AbstractRelease.schemaBase.cmDeadline,
    priceValidityStartDate: AbstractRelease_1.AbstractRelease.schemaBase.priceValidityStartDate,
    endDate: SelloutRelease_1.SelloutRelease.schema.endDate,
    exported: AbstractRelease_1.AbstractRelease.schemaBase.exported,
    favourite: AbstractRelease_1.AbstractRelease.schemaBase.favourite,
    totalPriceChangeLimit: SelloutRelease_1.SelloutRelease.schema.totalPriceChangeLimit,
    minPriceChangeInPercent: SelloutRelease_1.SelloutRelease.schema.minPriceChangeInPercent,
    maxPriceChangeInPercent: SelloutRelease_1.SelloutRelease.schema.maxPriceChangeInPercent,
    minMarginChangeInPercent: SelloutRelease_1.SelloutRelease.schema.minMarginChangeInPercent,
    stockValues: builder.opt(builder.obj('stockValues', SelloutImpactRecordStockValues_1.SelloutImpactRecordStockValues.schema, SelloutImpactRecordStockValues_1.SelloutImpactRecordStockValues.fromDataDict)),
    previousOpens: builder.listOf(builder.obj('previousOpens', SelloutReleasePreviousOpenOverview_1.SelloutReleasePreviousOpenOverview.schema, SelloutReleasePreviousOpenOverview_1.SelloutReleasePreviousOpenOverview.fromDataDict)),
    currentImpact: builder.opt(builder.obj('currentImpact', SelloutImpactRecordValuesForOpen_1.SelloutImpactRecordValuesForOpen.schema, SelloutImpactRecordValuesForOpen_1.SelloutImpactRecordValuesForOpen.fromDataDict)),
    // computed
    daysSinceFirstRepricing: builder.opt(builder.num('daysSinceFirstRepricing')),
    daysSinceLastRepricing: builder.opt(builder.num('daysSinceLastRepricing'))
  };
}(new StructPropBuilder_1.StructPropBuilder(CommonReleaseOverview.name));

CommonReleaseOverview.fieldsFromRelease = ['name', 'releaseType', 'workflowType', 'state', 'pricingType', 'priceListType', 'cmDeadline', 'priceValidityStartDate', 'endDate', 'exported', 'favourite', 'totalPriceChangeLimit', 'minPriceChangeInPercent', 'maxPriceChangeInPercent', 'minMarginChangeInPercent'];